import React from 'react';
import PropTypes from 'prop-types';

import { MUIModal } from 'Components/Base';

import ClearErrorContent from './ClearErrorContent';

const ClearErrorModal = ({
  onResendQuestion,
  onBackToClassroom,
  isOpen,
  toggleComponent,
  onOpenModal,
  onCloseModal,
  loading,
  ...props
}) => {
  return (
    <MUIModal
      isOpen={isOpen}
      toggleComponent={toggleComponent}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '343px', height: '410px' }}
      innerProps={{ height: '100%' }}
      closeIcon={false}
      disableBackdropClick
      {...props}
    >
      <ClearErrorContent
        onResendQuestion={onResendQuestion}
        onBackToClassroom={onBackToClassroom}
        loading={loading}
      />
    </MUIModal>
  );
};

ClearErrorModal.propTypes = {
  toggleComponent: PropTypes.element,
  onOpenModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onResendQuestion: PropTypes.func,
  onBackToClassroom: PropTypes.func,
};

export default ClearErrorModal;
